<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.error]="isError" [class.disabled]="isDisabled" class="f-form_checkbox">
    <input
      type="checkbox"
      [formControlName]="controlName"
      [id]="controlName"
      [name]="controlName"
      [attr.required]="isRequired ? '' : null"
      (change)="onChange($event)"
    />
    <label [for]="controlName" [innerHTML]="label" *ngIf="label"></label>
  </div>
  